import { Icon } from "../components/Icon";
import { SectionHeading } from "../components/SectionHeading";
import { RichText, useSiteTranslation } from "../i18n";
import "../styles/why.css";

const PILLAR_ICONS = ["heart", "lock", "family"];

export function WhySection() {
  const { t } = useSiteTranslation();
  const pillars = t("home.why.pillars", { returnObjects: true });

  return (
    <section className="section why" id="why">
      <div className="wrap">
        <SectionHeading
          layout="split"
          eyebrow={t("home.why.eyebrow")}
          title={<RichText k="home.why.title" />}
          lead={t("home.why.lead")}
        />

        <div className="pillar-grid">
          {pillars.map(({ title, text }, index) => (
            <article key={title} className="pillar" data-reveal style={{ "--delay": `${index * 0.08}s` }}>
              <span>
                <Icon name={PILLAR_ICONS[index]} />
              </span>
              <h3>{title}</h3>
              <p>{text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
